import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FiltersProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function Filters(props: FiltersProps) {
  return (
    <svg
      width="44"
      height="38"
      viewBox="0 0 44 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 116, left: 68}}
      onClick={props.onClick}
    >
      <path
        d="M42 37C43 37 43 36 43 36V2C43 2 43 1 42 1H38C37 1 37 2 37 2V5L7 9H2C1 9 1 10 1 10V28C1 28 1.0003 29 2 29H7L37 33V36C37 36 37.0003 37 38 37H42Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M43 2L43 36C43 36 43 37 42 37L38 37C37 37 37 36 37 36L37 2C37 2 37 1 38 1L42 1C43 1 43 2 43 2Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M37 5.00002L37 33L6.99998 29L6.99998 9L37 5.00002Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M37 19L7 19"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M7 11.6667L37 9M7 14.3333L37 12.7333M7 17L37 16"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M7 26.3333L37 29M7 23.6667L37 25.2667M7 21L37 22"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M7 9L7 29L2 29C1 29 1 28 1 28L1 10C1 10 1 9 2 9L7 9Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
